import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  event_types: [],
  event_type: null
}

// mutations
export const mutations = {
  [types.SET_EVENT_TYPES] (state, event_types) {
    state.event_types = event_types
  },
  [types.SET_EVENT_TYPE] (state, event_type) {
    state.event_type = event_type
  },
  [types.FETCH_EVENT_TYPE_FAILURE] (state) {
    state.event_type = null
  }
}

// actions
export const actions = {
  async fetchEventTypes ({ commit }) {
    try {
      const { data } = await axios.get('/api/event_types')
      commit(types.SET_EVENT_TYPES, data)
    } catch (e) {
      console.log(e)
    }
  },
  async fetchEventType ({ commit }, event_type) {
    try {
      const { data } = await axios.get(`/api/event_types/${event_type.id}`)

      commit(types.SET_EVENT_TYPE, { event_type: data })
    } catch (e) {
      commit(types.FETCH_EVENT_TYPE_FAILURE)
    }
  },

  async createEventType (context, event_type) {
    try {
      await axios.post('/api/event_types', event_type)
      context.dispatch('fetchEventTypes')
    } catch (e) {
      console.log(e)
    }
  },

  async updateEventType (context, event_type) {
    try {
      await axios.put(`/api/event_types/${event_type.id}`, event_type)
      context.dispatch('fetchEventTypes')
    } catch (e) { }
  },

  // eslint-disable-next-line camelcase
  async deleteEventType (context, event_type) {
    try {
      await axios.delete(`/api/event_types/${event_type.id}`)
      context.dispatch('fetchEventTypes')
    } catch (e) { }
  }
}

// getters
export const getters = {
  event_types: state => state.event_types
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/event-type.js